import React from 'react';
import { catalogColors } from './catalogColors';

interface UnionSegment {
  label: string;
  count: number;
  color: string;
  description: string;
}

interface UnionNoteProps {
  segments: UnionSegment[];
  total: number;
}

export function UnionNote({ segments, total }: UnionNoteProps) {
  return (
    <div className="ml-52 p-3 rounded-lg border text-xs space-y-2" style={{ borderColor: catalogColors.accentTeal + '40', backgroundColor: catalogColors.accentTeal + '08' }}>
      <div className="font-semibold text-[#0E9D8A]">How the union is composed</div>
      <div className="space-y-1">
        {segments.map((seg, i) => (
          <div key={i} className="flex items-start gap-2">
            <div className="w-2.5 h-2.5 rounded-sm shrink-0 mt-0.5" style={{ backgroundColor: seg.color }} />
            <div>
              <span className="font-medium">{seg.label}</span>
              <span className="text-muted-foreground"> — {seg.description}</span>
              <span className="ml-1 tabular-nums font-semibold" style={{ color: seg.color }}>({seg.count.toLocaleString()})</span>
            </div>
          </div>
        ))}
      </div>
      <div className="pt-1 border-t text-muted-foreground" style={{ borderColor: catalogColors.accentTeal + '30' }}>
        Union total: <span className="font-semibold text-foreground">{total.toLocaleString()}</span> AEO candidates. The overlap (products in both segments) is counted once.
      </div>
    </div>
  );
}
